import { Box, Dialog, DialogContent, IconButton, Slide, Table, TableBody, TableCell, TableRow, Divider } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useState, forwardRef, useEffect, useCallback } from 'react';
import dayjs from 'dayjs';
// Our Components
import { getACHCardTransactions } from 'lib/api/transactions';
import ChildAchTransactionsTable from './ChildAchTransactionsTable';
// Utils and Helpers
import { numberFormat } from 'helpers/i18n';
// Assets
import { ReactComponent as CalendarIcon } from 'assets/CalendarIcon.svg';
import { ReactComponent as CardCategoryIcon } from 'assets/CardCategoryIcon.svg';
import { ReactComponent as CardIcon } from 'assets/CardIcon.svg';
import { ReactComponent as TransactionIdIcon } from 'assets/transactionsSection/transactionIdIcon.svg';
import './AchDetails.css';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});

const AchDetails = ({
    isOpen,
    setOpen,
    achTransaction,
    statusFormatter,
    setIsAchCardTransactionDetailsOpen,
    setSelectedCardTransaction,
    achCardTransactionsRef
}) => {
    const [cardTransactionsInACH, setCardTransactionsInACH] = useState({
        results: [],
        total: 0
    });

    const handleTransactionDetailsClose = async () => {
        setOpen(false);
    };

    const fetchCardTransactionsInACH = useCallback(async () => {
        try {
            const cardTransactionsInACHData = await getACHCardTransactions(achTransaction?.id);
            setCardTransactionsInACH(cardTransactionsInACHData);
        } catch (error) {
            console.error(error);
        }
    }, [achTransaction?.id]);
    useEffect(() => {
        fetchCardTransactionsInACH();
    }, [fetchCardTransactionsInACH]);

    return (
        <Dialog
            id="ach-details"
            fullScreen
            open={isOpen}
            onClose={handleTransactionDetailsClose}
            TransitionComponent={Transition}>
            <DialogContent sx={{ width: '95%', margin: 'auto' }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="15px">
                    <Box className="ach_details__modal-title">ACH Details</Box>

                    <Box alignSelf="start">
                        <IconButton onClick={handleTransactionDetailsClose}>
                            <Close sx={{ fontSize: '20px', cursor: 'pointer' }} />
                        </IconButton>
                    </Box>
                </Box>
                <Box className="ach-details__banner">
                    <Box marginBottom="5px">{statusFormatter(achTransaction)}</Box>

                    <Box component="h3" className="ach-details__transaction-title">
                        {numberFormat(achTransaction.amount / 100, 2, 2)}
                    </Box>

                    <Box component="p" className="ach-details__transaction-description">
                        TOTAL AMOUNT
                    </Box>
                </Box>
                <Box display="flex" flex justifyContent="start" alignItems="flex-start" marginBottom="26px">
                    <Table className="ach-details__table" size="small">
                        <TableBody>
                            <TableRow className="ach-details__table-row" marginBottom="25px">
                                <TableCell sx={{ borderBottom: 'none' }}>
                                    <Box className="ach-details__data-label">
                                        <CalendarIcon />
                                        <Box marginLeft="11.5px"> Pull Date</Box>
                                    </Box>
                                </TableCell>
                                <TableCell className="ach-details__data-value" sx={{ borderBottom: 'none' }}>
                                    {dayjs(achTransaction?.transaction_date).format('MM/DD/YYYY')}
                                </TableCell>
                            </TableRow>
                            <TableRow className="ach-details__table-row" marginBottom="25px">
                                <TableCell sx={{ borderBottom: 'none', width: '30%' }}>
                                    <Box className="ach-details__data-label">
                                        <TransactionIdIcon />
                                        <Box marginLeft="11.5px"> Transaction Id</Box>
                                    </Box>
                                </TableCell>
                                <TableCell className="ach-details__data-value" sx={{ borderBottom: 'none' }}>
                                    {achTransaction?.id}
                                </TableCell>
                            </TableRow>
                            <TableRow className="ach-details__table-row" marginBottom="25px">
                                <TableCell sx={{ borderBottom: 'none' }}>
                                    <Box className="ach-details__data-label">
                                        <CardCategoryIcon />
                                        <Box marginLeft="11.5px"> Type</Box>
                                    </Box>
                                </TableCell>
                                <TableCell className="ach-details__data-value" sx={{ borderBottom: 'none' }}>
                                    ACH
                                </TableCell>
                            </TableRow>
                            <TableRow className="ach-details__table-row" marginBottom="25px">
                                <TableCell sx={{ borderBottom: 'none' }}>
                                    <Box className="ach-details__data-label">
                                        <CardIcon />
                                        <Box marginLeft="11.5px"> Bank Account</Box>
                                    </Box>
                                </TableCell>
                                <TableCell className="ach-details__data-value" sx={{ borderBottom: 'none' }}>
                                    {achTransaction?.bank_name} (*
                                    {achTransaction?.account_number?.slice(achTransaction?.account_number?.length - 4)})
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Box>
                <Divider sx={{ backgroundColor: '#D0D5D9' }} />
                {cardTransactionsInACH?.results?.length > 0 && (
                    <Box display="flex" flexDirection="column" alignItems="flex-start" marginTop="30px" width="100%">
                        <Box width="100%" marginLeft="auto" marginRight="auto">
                            <Box className="fw-bold" marginBottom="10px" color="var(--main-color)">
                                All Card Payments
                            </Box>
                            <ChildAchTransactionsTable
                                cardTransactionsInACH={cardTransactionsInACH}
                                setIsAchCardTransactionDetailsOpen={setIsAchCardTransactionDetailsOpen}
                                setSelectedCardTransaction={setSelectedCardTransaction}
                                achCardTransactionsRef={achCardTransactionsRef}
                            />
                        </Box>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default AchDetails;
